// http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=805000359
import config from '@/config/index';
import mockConfigApi from './mockConfig';
const cApi = config.cApiBase;
const cashierApi = config.cashierApiBase;

// 地址
const address = {
  POI_CHECK: cApi + '/entrega/addressCheck',
  ADDRESS_DEL: cApi + '/entrega/addressDel',
  ADDRESS_LIST: cApi + '/entrega/addressList',
  ADDRESS_SEARCH: cApi + '/address/textSearch',
  ADDRESS_REVERSE_POI: cApi + '/address/reversePoi', // http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=725328066 反解poi接口
  BATCH_QUERY_ADDRESS_POI: cApi + '/entregabusiness/textListSearch',
};

// 管控
const govern = {
  ENTREGA_RULES: cApi + '/entrega/serviceDesc',
  ENTREGA_ORDER_CANCEL: cApi + '/entrega/orderCancel',
  ENTREGA_ORDER_PRE_CANCEL: cApi + '/entrega/orderPreCancel',
};

// 提单
const bill = {
  BILL_INDEX: cApi + '/entregabusiness/home',
  COMPUTED_PRICE: cApi + '/entregabusiness/billInfo',
  CHECK_OPEN_TIME: cApi + '/entregabusiness/checkOpenTime',
};

// 订单
const order = {
  ORDER_LIST: cApi + '/entregabusiness/orderList', // 订单列表
  // * 以下接口名需按 capi wiki 调整
  ORDER_CANCEL: cApi + '/entrega/cancelV2',
  ORDER_DETAIL: cApi + '/entrega/orderDetail', // 订单详情
  ORDER_CREATE: cApi + '/entregabusiness/createOrder', // 创建B2C订单
  ORDER_CONTRACT_INFO: cApi + '/entregabusiness/getContractOrderInfo', // 查询契约单信息
  DEBT_REPAY: cApi + '/entrega/repay', // 欠款单
  DEBT_REPAY_FAIL: cApi + '/entrega/repayFail', // 欠款单还款失败
  ORDER_CONFIRM: cApi + '/entrega/confirmMeal', // 订单确认
};

// 支付
const pay = {
  PAY_GETPAYINFO: cApi + '/entrega/payMethodList',
  GET_PAY_STATUS: cashierApi + '/gulfstream/pay/v1/didipay/getPayStatus', // 支付状态
};

//公共接口
const common = {
  // 号码保护
  PROTECT_NUM: cApi + '/entrega/virtualTelPreCall',
  // 获取token
  GET_TOKEN: cApi + '/common/getToken',
  // 获取枚举
  GET_ENUM: cApi + '/entregabusiness/enum',
};

// 账户
const account = {
  // 查询账户信息
  QUERY_ACCOUNT: cApi + '/entregabusiness/accountInfo',
  // 添加账户信息
  ADD_ACCOUNT: cApi + '/entregabusiness/addAccount',
  // 更新账户信息
  UPDATE_ACCOUNT: cApi + '/entregabusiness/updateAccount',
};

const apiArr = [order, bill, pay, address, govern, common, account];

apiArr.map((item) => {
  return Object.assign(item, mockConfigApi);
});

export { order, bill, pay, address, govern, common, account };
